module.exports = __webpack_public_path__ + "img/billpay.6fd16176.svg";